module.exports = true;



//////////////////
// WEBPACK FOOTER
// C:/Source/hackathon/hackathon/web-app/node_modules/core-js/library/modules/_library.js
// module id = 64
// module chunks = 0